import api from "@/interceptors";
import { Route } from "../apiRoutes/routes";
import { DEFAULT_LANG_ID, localStorageKey } from "@/utils/constants";

export default class {
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  constructor() {}

  getLanguages(data: any) {
    return new Promise((resolve, reject) => {
      api
        .get(Route.languages, {
          params: { "g-recaptcha-response": data },
        } as any)
        .then((result) => {
          resolve(result);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  getLanguagesData(data: any) {
    const langId =
      localStorage.getItem(localStorageKey.languageId) || DEFAULT_LANG_ID;
    return new Promise((resolve, reject) => {
      api
        .get(Route.uiText, {
          params: { "g-recaptcha-response": data, langId },
        } as any)
        .then((result) => {
          resolve(result);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  copyTextToClipboard(text: string) {
    const el = document.createElement("textarea");
    el.value = text;
    el.setAttribute("readonly", "");
    el.style.position = "absolute";
    el.style.left = "-9999px";
    document.body.appendChild(el);
    el.select();
    document.execCommand("copy");
    document.body.removeChild(el);
  }

  removePropertyEmpty(obj: any) {
    const _obj = { ...obj };
    Object.keys(_obj).forEach(
      (key) =>
        (_obj[key] === null || _obj[key] === "" || _obj[key] === undefined) &&
        delete _obj[key],
    );
    return _obj;
  }

  setCursorLoading() {
    document.body.style.cursor = "wait";
  }

  setCursorDefault() {
    document.body.style.cursor = "default";
  }
}
